import { SAMPLE_MRZ } from './sample-data';
import { cmd, WebSocketServiceStubBase, WSStubResponse, WSSTUB_GENERIC_ERROR } from './web-socket-stub-base';

export class HWPassportWebSocketStub extends WebSocketServiceStubBase {
  override generateListOfCommands() {
    return [
      cmd('list-readers').withCallback(this.responseListReaders),
      cmd('connect').withDefaultResponse(),
      cmd('disconnect').withDefaultResponse(),
      cmd('perform-bac').withDefaultResponse(),
      cmd('read-data-group').withCallback(this.responseReadDataGroup),
      cmd('read-passport').withCallback(this.responseReadPassport),
      cmd('is-activated').withCallback(this.responseIsActivated),
      cmd('activate-by-code').withDefaultResponse(),
      cmd('check-dg3-cert').withDefaultResponse(WSSTUB_GENERIC_ERROR),
      cmd('update-dg3-cert').withDefaultResponse(),
      cmd('create-dg3').withDefaultResponse(WSSTUB_GENERIC_ERROR),
      cmd('perform-eac').withDefaultResponse(),
      cmd('list-cvcerts').withCallback(this.responseListCvcerts),
      cmd('list-terminal-keys').withCallback(this.responseListTerminalKeys),
      cmd('create-terminal-key').withCallback(this.responseCreateTerminalKey),
      cmd('get-cvcert').withDefaultResponse(WSSTUB_GENERIC_ERROR),
      cmd('get-cvcert-request').withDefaultResponse(WSSTUB_GENERIC_ERROR),
      cmd('install-cvcerts').withDefaultResponse(WSSTUB_GENERIC_ERROR),
      cmd('upload-cvca-links').withDefaultResponse(WSSTUB_GENERIC_ERROR),
    ];
  }

  private responseListReaders(data: any) {
    this.sendResponse(
      new WSStubResponse(data.command, {
        readers: [{ id: 0, name: 'test', sc_present: false }],
      }),
    );
  }

  private responseReadDataGroup(data: any) {
    if (data.parse === true) {
      if (data.id === 'DG1') {
        this.sendResponse(
          new WSStubResponse(data.command, {
            data: {
              mrz: SAMPLE_MRZ,
            },
            id: data.id,
          }),
        );
      } else if (data.id === 'DG2') {
        this.sendResponse(
          new WSStubResponse(data.command, {
            data: {
              'bio-info-templates': [
                {
                  'bio-data': {
                    'face-info': {
                      'face-images': [
                        {
                          'color-space': 'unspecified',
                          'data': '',
                          'device-type': 0,
                          'expression': 'unspecified',
                          'eye-color': 'unspecified',
                          'face-image-type': 'full frontal',
                          'feature-points': [],
                          'gender': 'unspecified',
                          'hair-color': 'unspecified',
                          'height': 320,
                          'image-data-type': 'jpeg2000',
                          'pose_angle_uncertainty': {
                            pitch: 0,
                            roll: 0,
                            yaw: 0,
                          },
                          'pose_angles': {
                            pitch: 0,
                            roll: 0,
                            yaw: 0,
                          },
                          'quality': 0,
                          'source-type': 'unspecified',
                          'width': 240,
                        },
                      ],
                      'version': '010',
                    },
                    'type': 'face info',
                  },
                  'bio-header-template': {
                    'bio-subtype': 0,
                    'bio-type': 2,
                    'format-owner': 257,
                    'format-type': 8,
                  },
                },
              ],
            },
            id: data.id,
          }),
        );
      } else if (data.id === 'DG3') {
        this.sendResponse(
          new WSStubResponse(
            data.command,
            {
              id: data.id,
            },
            WSSTUB_GENERIC_ERROR,
          ),
        );
      }
    } else if (data.id === 'SOD') {
      this.sendResponse(
        new WSStubResponse(data.command, {
          id: data.id,
        }),
      );
    } else if (data.id === 'GOST_SOD') {
      this.sendResponse(
        new WSStubResponse(data.command, {
          id: data.id,
        }),
      );
    } else {
      this.sendResponse(new WSStubResponse(data.command, undefined, WSSTUB_GENERIC_ERROR));
    }
  }

  private responseReadPassport(data: any) {
    this.sendResponse(
      new WSStubResponse(data.command, {
        'icao-bac': 'OK',
        'icao-eac': 'OK',
        'gost-bac': 'OK',
        'gost-eac': 'OK',
      }),
    );
  }

  private responseIsActivated(data: any) {
    this.sendResponse(
      new WSStubResponse(data.command, {
        activated: false,
      }),
    );
  }

  private responseListCvcerts(data: any) {
    this.sendResponse(
      new WSStubResponse(data.command, {
        certificates: [],
      }),
    );
  }

  private responseListTerminalKeys(data: any) {
    if (data.requests === true) {
      this.sendResponse(
        new WSStubResponse(data.command, {
          requests: [],
        }),
      );
    } else {
      this.sendResponse(
        new WSStubResponse(data.command, {
          keys: [],
        }),
      );
    }
  }

  private responseCreateTerminalKey(data: any) {
    this.sendResponse(new WSStubResponse(data.command, undefined, WSSTUB_GENERIC_ERROR));
  }
}
